export const ENVIRONMENT = (import.meta.env.VITE_ENVIRONMENT) as string;

export const IS_PROD = ENVIRONMENT === 'prod';
export const IS_LOCAL = ENVIRONMENT === 'local';
export const IS_DEV = ['dev01', 'dev02'].includes(ENVIRONMENT);
export const IS_STAGE = ['stage01'].includes(ENVIRONMENT);
export const IS_TEST = ['test01'].includes(ENVIRONMENT);

export const ENVIRONMENTS = {
  API_URL: import.meta.env.VITE_API_URL,
  REOWN_PROJECT_ID: import.meta.env.VITE_REOWN_PROJECT_ID,
  REOWN_APP_NAME: import.meta.env.VITE_REOWN_APP_NAME,
};
